import { render, staticRenderFns } from "./update.vue?vue&type=template&id=fca24222&scoped=true&"
import script from "./update.vue?vue&type=script&lang=js&"
export * from "./update.vue?vue&type=script&lang=js&"
import style0 from "./update.vue?vue&type=style&index=0&id=fca24222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca24222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fca24222')) {
      api.createRecord('fca24222', component.options)
    } else {
      api.reload('fca24222', component.options)
    }
    module.hot.accept("./update.vue?vue&type=template&id=fca24222&scoped=true&", function () {
      api.rerender('fca24222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/popups/profil/update.vue"
export default component.exports